import WhyTrackmateCard from "@/components/WhyTrackmate/WhyTrackmateCard"
import useResponsive from "@/hooks/useResponsive"
import { whyTrackmateData } from "@/utils/staticData/dataConstants"
import { Box } from "@mui/material"
import { EffectCards } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import "./styles.css"
import "swiper/css/effect-cards";

const CarouselSection = () => {
  const isMobile = useResponsive("down", "md");
  return (
    <Box
      component="section"
      pt={{ xs: 0, md: 6.25 }}
      pb={{ xs: 0, md: 6.25 }}
      bgcolor="background.default"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          width: "100%",
          height: "870px",
          position: "relative"
        }}
      >
        <Box
          component={Swiper}
          effect="cards"
          modules={[EffectCards]}
          grabCursor
          mousewheel={{
            invert: false,
          }}
          cardsEffect={{
            perSlideRotate: 0,
            perSlideOffset: isMobile ? 10 : 30,
            rotate: false,
            slideShadows: false
          }}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            overflow: "visible",
            transform: "translate(-50%, -50%)",
            width: { xs: "343px", md: "760px" },
            height: { xs: "770px", sm: "950px", md: "850px" }
          }}
        >
          {whyTrackmateData.map((data, index) => (
            <SwiperSlide key={index}>
              <WhyTrackmateCard
                key={index}
                title={data.title}
                subtitle={data.subtitle}
                benefits={data.benefits}
                imageUrl={data.imageUrl}
                sx={{
                  height: "100%",
                }}
              />
            </SwiperSlide>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CarouselSection;
